<div class="flex p-4 h-full">
  <div class="flex flex-col h-full flex-1">
    <div class="text-2xl text-center mb-4">{{ 'events.nextEvents' | translate }}</div>

    <div class="flex flex-col">
      @defer (hydrate on viewport) {
        @if (events.isLoading()) {
          <p-skeleton height="4.5rem" />
        } @else {
          @if (events.error()) {
            <span class="text-xl italic text-orange-500">
              {{ 'events.eventsError' | translate }}
            </span>
          } @else {
            @for (evt of events.value(); track $index) {
              <event-item
                [event]="evt"
                [location]="evt.location"
                (eventClicked)="selectEvent(evt)"
              ></event-item>
            } @empty {
              <span class="text-xl text-neutral-500 text-center"> {{ 'events.currentNoEvents' | translate }} </span>
            }
          }
        }
      } @placeholder {
          <p-skeleton height="4.5rem" />
      }
    </div>
  </div>

  <div class="w-0.5 h-[95%] mt-auto mb-auto bg-neutral-950"></div>

  <div class="flex flex-col h-full flex-3 p-4">
    @if (selectedEvent()) {
      <div class="text-xl font-bold mb-4">{{ selectedEvent().name }}</div>
      <div class="text-muted-color">
        {{ selectedEvent().startdate | date: 'dd MMM yyyy HH:mm' }} •
        {{ eventTimespan(selectedEvent().startdate, selectedEvent().enddate) | timespan }}
      </div>
      <div class="text-muted-color">{{ selectedEvent().location }}</div>

      @if (selectedEvent().description != '') {
        <div class="h-spacer"></div>
      }

      <div class="whitespace-pre-line">{{ selectedEvent().description }}</div>

      <!--         @if (eventCategory.value() && eventImages.value().length > 0) {
            <div class="h-spacer"></div>
            <div class="subtitle">{{ "events.images" | translate }}</div>
        } -->
    }
  </div>
</div>
